<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

              <el-form v-loading="loading" >
                <div style="padding: 10px;">
                  <input type="file" id="fileInput">
                  <button @click="upload()">Upload</button>
                </div>
              </el-form>


            </div>

        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Add',
        data() {
            return {
                loading: false,

                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                },

            }
        },

        methods: {
            init(){

            },
            closeSelf() {
                this.$emit("closeAdd");
            },




          upload() {

            let file = document.getElementById("fileInput").files[0];
            if(file == undefined){
              this.$message.info("请选择文件");
              return;
            }

            let chunkSize = 5 * 1024 * 1024; // 切片大小为5MB
            let totalChunks = Math.ceil(file.size / chunkSize); // 计算切片总数
            let randStr = timeStr +"-"+Math.floor(Math.random()*1000);

            this.loading =true;
            this.dd(randStr,file,chunkSize,totalChunks,0);

          },

          dd(randStr,file,chunkSize,totalChunks,index){

            let chunk = file.slice(index * chunkSize, (index + 1) * chunkSize);

            let fd = new FormData();
            fd.append("file", chunk);
            fd.append("fileName", file.name);
            fd.append("index", index);
            fd.append("totalChunks", totalChunks);
            fd.append("randStr", randStr);
            fd.append('staffCode',getStaffCode());
            fd.append('timeStr',timeStr);
            fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));


            let that = this;
            that.$axios.post(this.$shopUrl+'Upload/BigFile',fd).then(function(res){
              console.log(res.data);

              let indexNew = res.data.data.index;
              if(indexNew+1<totalChunks){
                that.dd(randStr,file,chunkSize,totalChunks,indexNew+1);
              }
              else{
                //MergeFile

                let fd = new FormData();
                fd.append("fileName", file.name);
                fd.append("totalChunks", totalChunks);
                fd.append("randStr", randStr);
                fd.append('staffCode',getStaffCode());
                fd.append('timeStr',timeStr);
                fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+that.$signKey));

                that.$axios.post(that.$shopUrl+'Upload/MergeFile',fd).then(function(res){
                  console.log(res.data);
                  that.loading =false;
                })

              }

            })

          },



        }
    }


</script>
<style lang="scss" scoped>

</style>
